import styled from 'styled-components/macro';
import { lighten } from 'polished';
import EmptyPage from '~/pages/EmptyPage';
import images from '~/constants/images';

export const ContentWrapper = styled.div`
  position: relative;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: 100%;
  opacity: ${({ isLoading }) => (isLoading ? 0.8 : 1)};
  transition: all 0.3s;
`;

export const EmptyPageDashboard = styled(EmptyPage)`
  background-color: ${({ theme }) => theme.white};
`;

export const DayMatches = styled.div`
  position: relative;
  width: calc(100% - 100px);
  margin-bottom: 20px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.xl}px`}) {
    width: calc(100% - 10px);
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
  }
`;

export const DayMatchesHeader = styled.div`
  padding-left: 35px;
  font-family: ${props => props.theme.primaryFontBold};
  font-size: ${props => props.theme.paragraphBig}px;
  text-transform: uppercase;
  color: ${props => props.theme.black};
  margin: 15px 0;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    padding-left: 15px;
    font-size: ${props => props.theme.paragraph}px;
  }
`;

export const DayMatchesContent = styled.div`
  border-top: 3px solid ${props => props.theme.white};
  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    border: 0;
  }
`;

export const MatchLeft = styled.div`
  width: 55%;
  height: 48px;
  padding: 10px 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  background-color: ${props => props.theme.dark};
  transition: all 0.3s;

  &:hover {
    background-color: ${props => lighten(0.1, props.theme.dark)};
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.xl}px`}) {
    padding: 10px 10px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
    height: 67px;
    padding: 0;
    display: grid;
    grid-template-columns: 20% 73% 7%;
    grid-template-areas: 'TIME COMPETITION LINK' 'TEAMS TEAMS TEAMS';
  }
`;

export const Match = styled.div`
  width: 100%;
  height: 48px;
  margin-top: 4px;
  display: flex;
  transition: all 0.3s;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    height: 120px;
    flex-direction: column;
    margin-bottom: 10px;
  }
`;

export const MatchTime = styled.div`
  width: 9%;
  color: ${props => props.theme.white};

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
    height: 30px;
    padding: 7px 0px 0 15px;
    grid-area: TIME;
  }
`;

export const Teams = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
    height: 37px;
    padding-bottom: 5px;
    grid-area: TEAMS;
  }
`;

export const LocalTeam = styled.div`
  width: calc(50% - 1px);
  display: flex;
  color: ${props => props.theme.white};
  text-transform: uppercase;
  align-items: center;
  justify-content: flex-end;
  padding-right: 15px;
  text-align: right;

  div {
    margin: 0 10px;
  }

  img {
    margin-left: 3px;
    width: 32px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    font-size: ${props => props.theme.paragraph}px;
    div {
      line-height: 1;
    }
  }
`;

export const Separator = styled.div`
  width: 2px;
  height: 17px;
  background-color: ${props => props.theme.coral};
`;

export const VisitorTeam = styled.div`
  width: calc(50% - 1px);
  display: flex;
  color: ${props => props.theme.white};
  text-transform: uppercase;
  align-items: center;
  justify-content: flex-start;
  padding-left: 15px;

  div {
    margin: 0 10px;
  }

  img {
    margin-right: 3px;
    width: 32px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    font-size: ${props => props.theme.paragraph}px;
    div {
      line-height: 1;
    }
  }
`;

export const CompetitionLogo = styled.div`
  width: 25%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 90%;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
    height: 30px;
    grid-area: COMPETITION;
    justify-content: flex-start;

    img {
      height: 30px;
      width: auto;
      padding: 5px 5px 0;
    }
  }
`;

export const MatchRight = styled.div`
  width: 50%;
  height: 48px;
  display: flex;
  background-color: ${props => props.theme.white};

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
  }
`;

export const MatchLinks = styled.div`
  width: calc(100% - 50px);
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    width: calc(100% / 6);
    padding: 5px 0 0;
    height: 48px;
    text-decoration: none;
    color: ${props => props.theme.dark};
    border-bottom: 5px solid transparent;
    div {
      padding: 5px 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      transition: border 0.3s;
      cursor: pointer;
    }
    &:hover {
      border-bottom: 5px solid ${props => props.theme.coral};
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
  }
`;

export const MatchRedirect = styled.button`
  width: 50px;
  height: 48px;
  background-color: ${({ theme, color }) => theme[color]};
  display: flex;
  justify-content: center;
  align-items: center;
  border-style: none;
  transition: all 0.3s;

  &:hover {
    background-color: ${({ theme }) => theme.dark};
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    width: 100%;

    svg {
      transform: rotate(${({ rotated }) => (rotated ? 90 : 0)}deg);
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    &:nth-child(3) {
      display: none;
    }
  }
`;

export const Pagination = styled.div`
  display: flex;
  padding: 20px;

  ul {
    display: flex;
    flex-direction: row;

    li {
      padding: 5px 7px;
      cursor: pointer;
      color: ${({ theme }) => theme.light};
      transition: all 0.3s;
      margin: 3px;

      &:hover {
        background-color: ${({ theme }) => theme.coral};
      }

      &.selected {
        color: ${({ theme }) => theme.coral};
        background-color: ${({ theme }) => theme.dark};
      }

      a {
        font-family: ${({ theme }) => theme.primaryFontMedium};
        font-size: ${({ theme }) => theme.h5}px;
      }
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
    height: auto;
    padding: 0 10px 20px;
    ul {
      width: 100%;
      justify-content: space-between;
      li {
        padding: 2%;
        margin: 0;
        a {
          font-size: ${props => props.theme.paragraph}px;
        }
      }
    }
  }
`;

export const ArrowIcon = styled.div`
  display: none;
  grid-area: LINK;
  padding: 9px 15px 0 0;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    display: block;
  }
`;

export const Background = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-attachment: fixed;
  background-image: url(${images.beat});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  opacity: 0.9;
  z-index: 0;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    background-size: 302%;
  }
`;
